import { useEffect, useState } from 'react';

export const useFormValidation = (provider, formData, isEditing = true) => {
	const [formErrors, setFormErrors] = useState({});

	useEffect(() => {
		if (!provider?.connect?.steps || !isEditing) {
			setFormErrors({});
			return;
		}

		const errors = {};
		for (const step of provider.connect.steps) {
			if (step.fields) {
				for (const field of step.fields) {
					if (!field.saveAs || field.type === 'ftp-details') continue;

					const value = formData[field.saveAs];

					if (field.required && !value) {
						errors[field.saveAs] = field.helpText || 'This field is required';
						continue;
					}

					if (field.regex && value) {
						const regex = new RegExp(field.regex);
						if (!regex.test(value)) {
							errors[field.saveAs] = field.helpText || 'Invalid format';
						}
					}
				}
			}
		}
		setFormErrors(errors);
	}, [formData, provider, isEditing]);

	return formErrors;
};
